import React, { createContext, useContext, useEffect } from "react";

// Dark mode a fost ELIMINAT — aplicația rulează DOAR pe light.
// Păstrăm API-ul (useTheme/toggle/setTheme) ca no-op, ca să nu stricăm consumatorii existenți.
const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

export function ThemeProvider({ children }) {
    useEffect(() => {
        // Light permanent: scoate clasa .dark și curăță orice preferință veche din localStorage.
        document.documentElement.classList.remove("dark");
        try { localStorage.setItem("tom-theme", "light"); } catch {}
    }, []);

    return (
        <ThemeContext.Provider value={{ theme: "light", setTheme: () => {}, toggle: () => {} }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
